import ButtonBlock from './ButtonBlock'
import DataCollectionSet from './DataCollectionSet'
import FactSet from './FactSet'
import Image from './ImageBlock'
import InputText from './InputText'
import TextBlock from './TextBlock'

export default {
  TextBlock,
  ButtonBlock,
  FactSet,
  'Input.Text': InputText,
  DataCollectionSet,
  Image
}
